import { render, staticRenderFns } from "./OrderExtraChargeModal.vue?vue&type=template&id=63502709&scoped=true&"
import script from "./OrderExtraChargeModal.vue?vue&type=script&lang=js&"
export * from "./OrderExtraChargeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63502709",
  null
  
)

export default component.exports